import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "content", "openButton", "closeButton" ]

  connect() {
    this.previouslyFocusedElement = null
    if (this.element.classList.contains("df-mobile-navbar")) {
      document.documentElement.classList.add("df-mobile-scrollbar-hidden")
    }
    this.setOpenState(false)
  }

  disconnect() {
    document.body.classList.remove("df-mobile-nav-open")
    document.documentElement.classList.remove("df-mobile-nav-open")
    if (this.element.classList.contains("df-mobile-navbar")) {
      document.documentElement.classList.remove("df-mobile-scrollbar-hidden")
    }
  }

  open(event) {
    event.preventDefault()
    if (this.isOpen) return

    this.previouslyFocusedElement = document.activeElement
    this.setOpenState(true)

    window.requestAnimationFrame(() => {
      if (this.hasCloseButtonTarget) this.closeButtonTarget.focus()
    })
  }

  close(event) {
    if (event) event.preventDefault()
    if (!this.isOpen) return

    this.setOpenState(false)

    const focusTarget = this.previouslyFocusedElement || (this.hasOpenButtonTarget && this.openButtonTarget)
    if (focusTarget && typeof focusTarget.focus === "function") focusTarget.focus()
    this.previouslyFocusedElement = null
  }

  toggle(event) {
    if (this.isOpen) {
      this.close(event)
    } else {
      this.open(event)
    }
  }

  keydown(event) {
    if (!this.isOpen) return

    if (event.key === "Tab") {
      this.keepFocusInside(event)
      return
    }

    if (event.key !== "Escape") return

    event.preventDefault()
    this.close()
  }

  keepFocusInside(event) {
    const focusableElements = Array.from(this.contentTarget.querySelectorAll(
      "a[href], button:not([disabled]), [tabindex]:not([tabindex='-1'])"
    )).filter((element) => element.getClientRects().length > 0)

    if (focusableElements.length === 0) return

    const firstElement = focusableElements[0]
    const lastElement = focusableElements[focusableElements.length - 1]

    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault()
      lastElement.focus()
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault()
      firstElement.focus()
    }
  }

  setOpenState(open) {
    this.contentTarget.classList.toggle("mobile-active", open)
    if (this.contentTarget.classList.contains("df-mobile-drawer")) {
      this.contentTarget.setAttribute("aria-hidden", String(!open))
      this.contentTarget.toggleAttribute("inert", !open)
    }
    document.body.classList.toggle("df-mobile-nav-open", open)
    document.documentElement.classList.toggle("df-mobile-nav-open", open)

    if (this.hasOpenButtonTarget) {
      this.openButtonTarget.setAttribute("aria-expanded", String(open))
      this.openButtonTarget.setAttribute("aria-label", open ? "Fermer le menu" : "Ouvrir le menu")
    }
  }

  get isOpen() {
    return this.contentTarget.classList.contains("mobile-active")
  }
}
